import { find } from 'lodash';
import React, { FC, Suspense } from 'react';
import { useParams } from 'react-router-dom';
import { SuspenseLoader, ErrorBoundary } from '@bechtel/client-common';
import { ProjectAdminMenuItem, ProjectAdminMenuType } from '../list/types';
import { ProjectAdminDetailContainerStyled } from './styled';
import { ProjectAdminDetailProps } from './types';
import { UserAdmin } from '../user-admin';
import { ManageGeneralSettings } from '../general';
import { WorkPackageAdmin } from '../work-package-admin';
import { QuantityReporting } from '../quantity-reporting';
import { ModuleAdmin } from '../module-admin';
import { WeldSetup } from '~/weld-setup';
import { RodRooms } from '~/rod-rooms';
import { Sync } from '~/sync';

import { Features } from '~/features';
import { DataVaults } from '~/data-vault';
import { Reports } from '~/report';
import { useProjectAdminMenu } from '~/list/hooks';
interface RouteParams {
  id: string;
}

export const ProjectAdminDetail: FC<ProjectAdminDetailProps> = ({ isListCollapsed }) => {
  const { id } = useParams<RouteParams>();
  const { getProjectAdminMenuItems } = useProjectAdminMenu();
  const menuItem = find(getProjectAdminMenuItems(), (item: ProjectAdminMenuItem) => {
    return item.value == id;
  });

  return (
    <ProjectAdminDetailContainerStyled isListCollapsed={isListCollapsed}>
      {menuItem && menuItem.type === ProjectAdminMenuType.USER_ADMIN && (
        <ErrorBoundary>
          <Suspense fallback={<SuspenseLoader></SuspenseLoader>}>
            <UserAdmin />
          </Suspense>
        </ErrorBoundary>
      )}
      {menuItem && menuItem.type === ProjectAdminMenuType.GENERAL && (
        <ErrorBoundary>
          <Suspense fallback={<SuspenseLoader></SuspenseLoader>}>
            <ManageGeneralSettings />
          </Suspense>
        </ErrorBoundary>
      )}
      {menuItem && menuItem.type === ProjectAdminMenuType.WORK_PACKAGES && (
        <ErrorBoundary>
          <Suspense fallback={<SuspenseLoader></SuspenseLoader>}>
            <WorkPackageAdmin />
          </Suspense>
        </ErrorBoundary>
      )}
      {menuItem && menuItem.type === ProjectAdminMenuType.QUANTITY_REPORTING && (
        <ErrorBoundary>
          <Suspense fallback={<SuspenseLoader></SuspenseLoader>}>
            <QuantityReporting />
          </Suspense>
        </ErrorBoundary>
      )}
      {menuItem && menuItem.type === ProjectAdminMenuType.MODULES && (
        <ErrorBoundary>
          <Suspense fallback={<SuspenseLoader></SuspenseLoader>}>
            <ModuleAdmin />
          </Suspense>
        </ErrorBoundary>
      )}
      {menuItem && menuItem.type === ProjectAdminMenuType.WELD_SETUP && (
        <ErrorBoundary>
          <Suspense fallback={<SuspenseLoader></SuspenseLoader>}>
            <WeldSetup />
          </Suspense>
        </ErrorBoundary>
      )}
      {menuItem && menuItem.type === ProjectAdminMenuType.ROD_ROOMS && (
        <ErrorBoundary>
          <Suspense fallback={<SuspenseLoader></SuspenseLoader>}>
            <RodRooms />
          </Suspense>
        </ErrorBoundary>
      )}
      {menuItem && menuItem.type === ProjectAdminMenuType.SYNC && (
        <ErrorBoundary>
          <Suspense fallback={<SuspenseLoader></SuspenseLoader>}>
            <Sync />
          </Suspense>
        </ErrorBoundary>
      )}
      {menuItem && menuItem.type === ProjectAdminMenuType.FEATURES && (
        <ErrorBoundary>
          <Suspense fallback={<SuspenseLoader></SuspenseLoader>}>
            <Features />
          </Suspense>
        </ErrorBoundary>
      )}
      {menuItem && menuItem.type === ProjectAdminMenuType.DATA_VAULT && (
        <ErrorBoundary>
          <Suspense fallback={<SuspenseLoader></SuspenseLoader>}>
            <DataVaults />
          </Suspense>
        </ErrorBoundary>
      )}
      {menuItem && menuItem.type === ProjectAdminMenuType.REPORT && (
        <ErrorBoundary>
          <Suspense fallback={<SuspenseLoader></SuspenseLoader>}>
            <Reports />
          </Suspense>
        </ErrorBoundary>
      )}
    </ProjectAdminDetailContainerStyled>
  );
};
